import custas from "../../constants/custas"

class Selo {
  constructor (data) {
    this.selo_id = null
    this.registro_id = null
    this.tipo_ato = null // Siglas
    this.envio_tj = null
    this.num_selo = null
    this.qrcode = null
    this.num_selo_retificador = null
    this.qrcode_retificador = null
    this.num_ordem_judicial = null
    this.atualizar_tj = null
    this.cancelado_tj = null
    this.excluido_tj = null
    this.erro_assinatura = null
    this.data_envio_tj = null
    this.excluido_tj = null
    this.erro_assinatura = null
    this.data_envio_tj = null
    this.data_cancelamento = null
    this.created_at = null
    this.updated_at = null
    this.tipoSelo = null // Fisico, Digital

    // estados para o front
    this.numero_serie = null // Usado em selos físicos
    this.codigoServentia = null // Usado em selos físicos
    this.retificarSelo = false
    this.excluirSelo = false
    this.cancelarSelo = false

    if (data) this.__init(data)
  }

  __init (data) {
    Object.assign(this, data)
    this.tipoSelo = custas.selosFisicos.includes(data.ato) ? 'Fisico' : 'Digital'
  }

}

export default Selo